/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _calc = __webpack_require__(5);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _toolbar = __webpack_require__(8);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _ruling = __webpack_require__(10);
	
	var _ruling2 = _interopRequireDefault(_ruling);
	
	var _partnerSection = __webpack_require__(12);
	
	var _partnerSection2 = _interopRequireDefault(_partnerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('dit-calculator', ['ngMaterial'], ["$locationProvider", function ($locationProvider) {
	    $locationProvider.html5Mode(true);
	}]).component('calc', _calc2.default).component('toolbar', _toolbar2.default).component('ruling', _ruling2.default).component('partnerSection', _partnerSection2.default);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js?minimize!./styles.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js?minimize!./styles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".report-value{font-weight:700;text-align:right;color:#000}.report-value-negative{color:#f36}.title{position:relative;line-height:13px}.motto{font-style:italic;opacity:.6}.github-alt,.motto{display:inline-block}.github-alt{width:25px;height:25px;background-size:25px 25px;background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik03MDQgMTIxNnEwIDQwLTEyLjUgODJ0LTQzIDc2LTcyLjUgMzQtNzIuNS0zNC00My03Ni0xMi41LTgyIDEyLjUtODIgNDMtNzYgNzIuNS0zNCA3Mi41IDM0IDQzIDc2IDEyLjUgODJ6bTY0MCAwcTAgNDAtMTIuNSA4MnQtNDMgNzYtNzIuNSAzNC03Mi41LTM0LTQzLTc2LTEyLjUtODIgMTIuNS04MiA0My03NiA3Mi41LTM0IDcyLjUgMzQgNDMgNzYgMTIuNSA4MnptMTYwIDBxMC0xMjAtNjktMjA0dC0xODctODRxLTQxIDAtMTk1IDIxLTcxIDExLTE1NyAxMXQtMTU3LTExcS0xNTItMjEtMTk1LTIxLTExOCAwLTE4NyA4NHQtNjkgMjA0cTAgODggMzIgMTUzLjV0ODEgMTAzIDEyMiA2MCAxNDAgMjkuNSAxNDkgN2gxNjhxODIgMCAxNDktN3QxNDAtMjkuNSAxMjItNjAgODEtMTAzIDMyLTE1My41em0yMjQtMTc2cTAgMjA3LTYxIDMzMS0zOCA3Ny0xMDUuNSAxMzN0LTE0MSA4Ni0xNzAgNDcuNS0xNzEuNSAyMi0xNjcgNC41cS03OCAwLTE0Mi0zdC0xNDcuNS0xMi41LTE1Mi41LTMwLTEzNy01MS41LTEyMS04MS04Ni0xMTVxLTYyLTEyMy02Mi0zMzEgMC0yMzcgMTM2LTM5Ni0yNy04Mi0yNy0xNzAgMC0xMTYgNTEtMjE4IDEwOCAwIDE5MCAzOS41dDE4OSAxMjMuNXExNDctMzUgMzA5LTM1IDE0OCAwIDI4MCAzMiAxMDUtODIgMTg3LTEyMXQxODktMzlxNTEgMTAyIDUxIDIxOCAwIDg3LTI3IDE2OCAxMzYgMTYwIDEzNiAzOTh6IiBmaWxsPSIjZmZmIi8+PC9zdmc+)}md-input-container{display:inline}md-input-container label:not(.md-container-ignore){position:static}md-input-container .md-input{width:auto;float:none}md-checkbox:last-of-type{margin:inherit}md-radio-group{margin-left:20px!important}.disclaimer{font-size:75%}.collapsible-item{overflow:hidden}.collapsible-heading{cursor:pointer;position:relative;z-index:100000000}.collapsible-heading:focus{outline:none;border:0}.collapsible-item:first-of-type{border-top:0}.collapsible-heading-collapsed p{font-size:16px;font-weight:400;margin:0}.collapsible-heading-expanded p{font-size:16px;font-weight:700;margin:0}.collapsible-content{padding:20px}.slide-down.ng-hide{height:0}.slide-down,.slide-down.ng-hide{transition:height .35s ease;overflow:hidden;position:relative}.slide-down{height:100%}.slide-down.ng-hide-add,.slide-down.ng-hide-remove{display:block!important}.slide-down.ng-hide-add{animation-name:hide;-webkit-animation-name:hide;animation-duration:.5s;-webkit-animation-duration:.5s;animation-timing-function:ease-in;-webkit-animation-timing-function:ease-in}.slide-down.ng-hide-remove{animation-name:show;-webkit-animation-name:show;animation-duration:.5s;-webkit-animation-duration:.5s;animation-timing-function:ease-out;-webkit-animation-timing-function:ease-out}.md-select-value .md-select-icon:after{font-size:0}md-checkbox.md-checked .md-icon{background-color:#4051b5}md-radio-button.md-checked .md-off{border-color:#4051b5}md-radio-button .md-on{background-color:#4051b5}", ""]);
	
	// exports


/***/ },
/* 3 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(6);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _data = __webpack_require__(7);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Get JSON containing calculation constants
	
	var calcComponent = {
	  template: _calc2.default,
	  controller: function controller($scope, $location) {
	    var _this = this;
	
	    this.year = _data2.default.currentYear;
	    this.years = _data2.default.years;
	    if ($location.search().year && this.years.indexOf(+$location.search().year) !== -1) {
	      this.year = +$location.search().year;
	    }
	
	    this.startFrom = $location.search().startFrom || 'Year';
	    this.startFromPrevious = $location.search().startFromPrevious || 'Year';
	    this.startFromSocialPrevious = $location.search().startFromSocialPrevious || 'Year';
	
	    this.salary = {
	      income: +$location.search().salary || 36000,
	      incomePrevious: +$location.search().salaryPrevious || 36000,
	      socialPrevious: +$location.search().socialPrevious || 4264,
	      allowance: !!+$location.search().allowance || false,
	      socialSecurity: angular.isDefined($location.search().socialSecurity) && $location.search().socialSecurity === '0' ? false : true,
	      older: !!+$location.search().retired || false,
	      hours: +$location.search().hours || _data2.default.defaultWorkingHours
	    };
	
	    this.ruling = {
	      checked: !!+$location.search().ruling || false,
	      choice: $location.search().rulingChoice || 'normal'
	    };
	
	    this.output = [{
	      'name': 'grossAllowance',
	      'sign': '',
	      'title': 'Year Gross Holiday Allowance',
	      'checked': !!+$location.search().grossAllowance || false
	    }, {
	      'name': 'grossYear',
	      'sign': '',
	      'title': 'Year Gross Income',
	      'checked': !!+$location.search().grossYear || false
	    }, {
	      'name': 'grossMonth',
	      'sign': '',
	      'title': 'Month Gross Income',
	      'checked': !!+$location.search().grossMonth || true
	    }, {
	      'name': 'grossWeek',
	      'sign': '',
	      'title': 'Week Gross Income',
	      'checked': !!+$location.search().grossWeek || false
	    }, {
	      'name': 'grossDay',
	      'sign': '',
	      'title': 'Day Gross Income',
	      'checked': !!+$location.search().grossDay || false
	    }, {
	      'name': 'grossHour',
	      'sign': '',
	      'title': 'Hour Gross Income',
	      'checked': !!+$location.search().grossHour || false
	    }, {
	      'name': 'taxFreeYear',
	      'sign': '-',
	      'title': 'Tax Free Income',
	      'checked': !!+$location.search().taxFreeYear || true
	    }, {
	      'name': 'taxFree',
	      'sign': '',
	      'title': 'Ruling Real Percentage',
	      'checked': !!+$location.search().taxFree || false
	    }, {
	      'name': 'taxableYear',
	      'sign': '',
	      'title': 'Taxable Income',
	      'checked': !!+$location.search().taxableYear || true
	    }, {
	      'name': 'taxableYearAfterGeneralCredit',
	      'sign': '',
	      'title': 'Taxable Income (after General Credit)',
	      'checked': !!+$location.search().taxableYearAfterGeneralCredit || true
	    }, {
	      'name': 'payrollTax',
	      'sign': '',
	      'title': 'Payroll Tax',
	      'checked': !!+$location.search().payrollTax || true
	    }, {
	      'name': 'socialTax',
	      'sign': '',
	      'title': 'Social Security Tax (ZZZS, ZPIZ, etc.)',
	      'checked': !!+$location.search().socialTax || true
	    }, {
	      'name': 'generalCredit',
	      'sign': '+',
	      'title': 'General Tax Credit',
	      'checked': !!+$location.search().generalCredit || false
	    }, {
	      'name': 'labourCredit',
	      'sign': '+',
	      'title': 'Labour Tax Credit',
	      'checked': !!+$location.search().labourCredit || false
	    }, {
	      'name': 'incomeTax',
	      'sign': '-',
	      'title': 'Total Income Tax',
	      'checked': !!+$location.search().incomeTax || false
	    }, {
	      'name': 'netAllowance',
	      'sign': '',
	      'title': 'Year Net Holiday Allowance',
	      'checked': !!+$location.search().netAllowance || false
	    }, {
	      'name': 'netYear',
	      'sign': '',
	      'title': 'Year Net Income',
	      'checked': !!+$location.search().netYear || true
	    }, {
	      'name': 'netMonth',
	      'sign': '',
	      'title': 'Month Net Income',
	      'checked': !!+$location.search().netMonth || true
	    }, {
	      'name': 'netWeek',
	      'sign': '',
	      'title': 'Week Net Income',
	      'checked': !!+$location.search().netWeek || false
	    }, {
	      'name': 'netDay',
	      'sign': '',
	      'title': 'Day Net Income',
	      'checked': !!+$location.search().netDay || false
	    }, {
	      'name': 'netHour',
	      'sign': '',
	      'title': 'Hour Net Income',
	      'checked': !!+$location.search().netHour || false
	    }];
	
	    $scope.$watchGroup(['$ctrl.year', '$ctrl.startFrom', '$ctrl.salary.income', '$ctrl.salary.incomePrevious', '$ctrl.salary.socialPrevious', '$ctrl.salary.allowance', '$ctrl.salary.socialSecurity', '$ctrl.salary.older', '$ctrl.ruling.checked'],
	    /*        '$ctrl.ruling.choice',
	            '$ctrl.salary.hours',
	          ].concat(this.output.map((item, index) => {
	              return '$ctrl.output[' + index + '].checked';
	            })),*/
	    function () {
	      $location.search('year', +_this.year);
	      $location.search('startFrom', _this.startFrom);
	      $location.search('startFromPrevious', _this.startFromPrevious);
	      $location.search('salary', +_this.salary.income);
	      $location.search('salaryPrevious', +_this.salary.incomePrevious);
	      $location.search('socialPrevious', +_this.salary.socialPrevious);
	      $location.search('allowance', +_this.salary.allowance);
	      $location.search('socialSecurity', +_this.salary.socialSecurity);
	      $location.search('retired', +_this.salary.older);
	      $location.search('ruling', +_this.ruling.checked);
	      /*        $location.search('rulingChoice', this.ruling.choice);
	              $location.search('hours', +this.salary.hours);
	              this.output.forEach((item) => {
	                $location.search(item.name, +item.checked);
	              });*/
	
	      // For calculation instructions:
	      // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/rekenvoorschriften-voor-de-geautomatiseerde-loonadministratie-januari-2017
	
	      var salary = _this.salary;
	      salary.grossYear = salary.grossMonth = salary.grossWeek = salary.grossDay = salary.grossHour = 0;
	      salary['gross' + _this.startFrom] = salary.income;
	      var grossYear = salary.grossYear + salary.grossMonth * 12 + salary.grossWeek * _data2.default.workingWeeks;
	      grossYear += salary.grossDay * _data2.default.workingDays + salary.grossHour * _data2.default.workingWeeks * salary.hours;
	      if (!grossYear || grossYear < 0) {
	        grossYear = 0;
	      }
	
	      salary.grossPreviousYear = salary.grossPreviousMonth = salary.grossPreviousWeek = salary.grossPreviousDay = salary.grossPreviousHour = 0;
	      salary['grossPrevious' + _this.startFromPrevious] = salary.incomePrevious;
	      var grossPreviousYear = salary.grossPreviousYear + salary.grossPreviousMonth * 12 + salary.grossPreviousWeek * _data2.default.workingWeeks;
	      grossPreviousYear += salary.grossPreviousDay * _data2.default.workingDays + salary.grossPreviousHour * _data2.default.workingWeeks * salary.hours;
	      if (!grossPreviousYear || grossPreviousYear < 0) {
	        grossPreviousYear = 0;
	      }
	
	      salary.socialPreviousYear = salary.socialPreviousMonth = salary.socialPreviousWeek = salary.socialPreviousDay = salary.socialPreviousHour = 0;
	      salary['socialPrevious' + _this.startFromSocialPrevious] = salary.socialPrevious;
	      var socialPreviousYear = salary.socialPreviousYear + salary.socialPreviousMonth * 12 + salary.socialPreviousWeek * _data2.default.workingWeeks;
	      socialPreviousYear += salary.socialPreviousDay * _data2.default.workingDays + salary.socialPreviousHour * _data2.default.workingWeeks * salary.hours;
	      if (!socialPreviousYear || socialPreviousYear < 0) {
	        socialPreviousYear = 0;
	      }
	
	      salary.grossAllowance = salary.allowance ? ~~(grossYear * (0.08 / 1.08)) : 0; // Vakantiegeld (8%)
	      salary.grossYear = ~~grossYear;
	      salary.grossMonth = ~~(grossYear / 12);
	      salary.grossWeek = ~~(grossYear / _data2.default.workingWeeks);
	      salary.grossDay = ~~(grossYear / _data2.default.workingDays);
	      salary.grossHour = ~~(grossYear / (_data2.default.workingWeeks * salary.hours));
	
	      salary.grossPreviousYear = ~~grossPreviousYear;
	      salary.grossPreviousMonth = ~~(grossPreviousYear / 12);
	      salary.grossPreviousWeek = ~~(grossPreviousYear / _data2.default.workingWeeks);
	      salary.grossPreviousDay = ~~(grossPreviousYear / _data2.default.workingDays);
	      salary.grossPreviousHour = ~~(grossPreviousYear / (_data2.default.workingWeeks * salary.hours));
	
	      salary.socialPreviousYear = ~~socialPreviousYear;
	      salary.socialPreviousMonth = ~~(socialPreviousYear / 12);
	      salary.socialPreviousWeek = ~~(socialPreviousYear / _data2.default.workingWeeks);
	      salary.socialPreviousDay = ~~(socialPreviousYear / _data2.default.workingDays);
	      salary.socialPreviousHour = ~~(socialPreviousYear / (_data2.default.workingWeeks * salary.hours));
	
	      salary.taxFreeYear = 0;
	      salary.taxableYear = grossYear - salary.grossAllowance;
	      salary.taxFreeYear = salary.taxableYear * (1 - _data2.default.nominalExpenseRates[_this.year]);
	
	      salary.taxableYear = getTaxableIncome(_this.year, salary.taxableYear);
	
	      salary.taxFreeYear = ~~salary.taxFreeYear;
	      salary.taxFree = ~~(salary.taxFreeYear / grossYear * 100);
	      salary.taxableYear = ~~salary.taxableYear;
	      var socialCredit = getSocialCredit(_this.year, salary.older, salary.socialSecurity);
	      salary.generalCredit = socialCredit * getGeneralCredit(_this.year, salary.taxableYear, salary.older);
	
	      salary.taxableYearAfterGeneralCredit = salary.taxableYear - salary.generalCredit;
	      if (salary.taxableYearAfterGeneralCredit < 0) {
	        salary.taxableYearAfterGeneralCredit = 0;
	      }
	      salary.payrollTax = -1 * getPayrollTax(_this.year, salary.taxableYearAfterGeneralCredit);
	      salary.taxablePreviousYear = getTaxableIncome(_this.year - 1, salary.grossPreviousYear);
	      var socialTaxBase = (salary.taxablePreviousYear + salary.socialPreviousYear) * 0.75;
	      salary.socialTax = salary.socialSecurity ? -1 * getSocialTax(_this.year, socialTaxBase, salary.older) : 0;
	      if (Math.abs(salary.socialTax) < 4264.32) {
	        salary.socialTax = -4264.32;
	      }
	      if (Math.abs(salary.socialTax) > 25424.52) {
	        salary.socialTax = -25424.52;
	      }
	      salary.generalCredit = socialCredit * getGeneralCredit(_this.year, salary.taxableYear, salary.older);
	      salary.labourCredit = socialCredit * getLabourCredit(_this.year, salary.taxableYear, salary.older);
	      salary.incomeTax = ~~(salary.payrollTax + salary.socialTax + salary.labourCredit);
	      salary.incomeTax = salary.incomeTax < 0 ? salary.incomeTax : 0;
	      salary.netYear = salary.taxableYear + salary.incomeTax + salary.taxFreeYear;
	      salary.netAllowance = salary.allowance ? ~~(salary.netYear * (0.08 / 1.08)) : 0;
	      //salary.netYear -= salary.netAllowance; // Remove holiday allowance from annual net amount
	      salary.netMonth = ~~(salary.netYear / 12);
	      salary.netWeek = ~~(salary.netYear / _data2.default.workingWeeks);
	      salary.netDay = ~~(salary.netYear / _data2.default.workingDays);
	      salary.netHour = ~~(salary.netYear / (_data2.default.workingWeeks * salary.hours));
	    });
	
	    // 30% Ruling (30%-regeling)
	    // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/internationaal/werken_wonen/tijdelijk_in_een_ander_land_werken/u_komt_in_nederland_werken/30_procent_regeling/voorwaarden_30_procent_regeling/u_hebt_een_specifieke_deskundigheid
	    function getRulingIncome(year, ruling) {
	      return _data2.default.rulingThreshold[year][ruling || 'normal'];
	    }
	
	    function getTaxableIncome(year, salary) {
	      console.log(_data2.default.nominalExpenseRates[year]);
	      console.log(salary);
	      console.log(_data2.default.nominalExpenseRates[year] * salary);
	      return _data2.default.nominalExpenseRates[year] * salary;
	    }
	
	    // Payroll Tax Rates (Loonbelasting)
	    // https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/HL/stappenplan-stap_7_loonbelasting_premie_volksverzekeringen.html
	    function getPayrollTax(year, salary) {
	      return getRates(_data2.default.payrollTax[year], salary, 'rate', year);
	    }
	
	    // Social Security Contribution (Volksverzekeringen - AOW, Anw, Wlz)
	    // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/werk_en_inkomen/sociale_verzekeringen/premies_volks_en_werknemersverzekeringen/volksverzekeringen/volksverzekeringen?projectid=98f8c360-e92a-4fe2-aea6-27e9087ce4a1&projectid=98f8c360-e92a-4fe2-aea6-27e9087ce4a1
	    function getSocialTax(year, salary, older) {
	      return getRates(_data2.default.socialPercent[year], salary, older ? 'older' : 'social', year);
	    }
	
	    // General Tax Credit (Algemene Heffingskorting)
	    // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/inkomstenbelasting/heffingskortingen_boxen_tarieven/heffingskortingen/algemene_heffingskorting/
	    function getGeneralCredit(year, salary) {
	      return getRates(_data2.default.generalCredit[year], salary, 'rate', year);
	    }
	
	    // Labour Tax Credit (Arbeidskorting)
	    // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/inkomstenbelasting/heffingskortingen_boxen_tarieven/heffingskortingen/arbeidskorting/
	    function getLabourCredit(year, salary) {
	      return getRates(_data2.default.labourCredit[year], salary, 'rate', year);
	    }
	
	    // Social Security Contribution (Volksverzekeringen) Component of Tax Credit
	    // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/internationaal/fiscale_regelingen/sociale_zekerheid_bij_grensoverschrijdend_werken_en_ondernemen/hoe_wordt_de_premie_berekend/berekening_premie_volksverzekeringen_heffingskorting_deel_van_het_jaar_premieplichtig/heffingskortingen/
	    function getSocialCredit(year, older, socialSecurity) {
	      /*
	      * JSON properties for socialPercent object
	      * rate: Higher full rate including social contributions to be used to get proportion
	      * social: Percentage of social contributions (AOW + Anw + Wlz)
	      * older: Percentage for retirement age (Anw + Wlz, no contribution to AOW)
	      */
	      var bracket = _data2.default.socialPercent[year][0],
	          percentage = 1;
	      if (!socialSecurity) {
	        percentage = (bracket.rate - bracket.social) / bracket.rate; // Removing AOW + Anw + Wlz from total
	      } else if (older) {
	        percentage = (bracket.rate + bracket.older - bracket.social) / bracket.rate; // Removing only AOW from total
	      }
	      return percentage;
	    }
	
	    // https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/handboek-loonheffingen-2017
	    function getRates(brackets, taxableSalary, type, year) {
	      var amount = 0,
	          tax = void 0,
	          delta = void 0,
	          percent = void 0;
	
	      brackets.some(function (bracket, index) {
	        delta = bracket.max ? bracket.max - bracket.min : Infinity; // Consider infinity when no upper bound
	        tax = type && bracket[type] ? bracket[type] : bracket['rate'];
	        percent = tax != 0 && tax > -1 && tax < 1; // Check if rate is percentage or fixed
	        if (taxableSalary <= delta) {
	          if (percent) {
	            amount += Math.trunc(taxableSalary * 100 * tax) / 100; // Round down at 2 decimal places
	          } else {
	            amount = tax;
	          }
	          //console.log(index, taxableSalary, delta, tax, percent, amount);
	          return true; // Break loop when reach last bracket
	        } else {
	          if (percent) {
	            amount += delta * tax;
	          } else {
	            amount = tax;
	          }
	          taxableSalary -= delta;
	        }
	      });
	      return amount;
	    }
	  }
	};
	
	exports.default = calcComponent;

/***/ },
/* 6 */
/***/ function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<md-content class=\"md-body-1\" layout-lg=\"column\" layout-gt-lg=\"column\" layout-align=\"center\" layout-margin> <div layout=\"row\" layout-align=\"start\" flex> <md-input-container class=\"md-display-1 md-default-theme\"> <label>Gross Income</label> <input type=\"number\" ng-model=\"$ctrl.salary.income\" min=\"1\" autofocus required> </md-input-container> <md-input-container class=\"md-display-1 md-default-theme\"> &nbsp; <md-select ng-model=\"$ctrl.startFrom\"> <md-option value=\"Year\">year</md-option> <md-option value=\"Month\">month</md-option> <md-option value=\"Week\">week</md-option> <md-option value=\"Day\">day</md-option> <md-option value=\"Hour\">hour</md-option> </md-select> </md-input-container> </div> <div layout=\"row\" layout-align=\"start\" flex> <md-input-container class=\"md-display-1 md-default-theme\"> <label>Gross Income - Previous</label> <input type=\"number\" ng-model=\"$ctrl.salary.incomePrevious\" min=\"1\" autofocus required> </md-input-container> <md-input-container class=\"md-display-1 md-default-theme\"> &nbsp; <md-select ng-model=\"$ctrl.startFromPrevious\"> <md-option value=\"Year\">year</md-option> <md-option value=\"Month\">month</md-option> <md-option value=\"Week\">week</md-option> <md-option value=\"Day\">day</md-option> <md-option value=\"Hour\">hour</md-option> </md-select> </md-input-container> </div> <div layout=\"row\" layout-align=\"start\" flex> <md-input-container class=\"md-display-1 md-default-theme\"> <label>Social Taxes - Previous</label> <input type=\"number\" ng-model=\"$ctrl.salary.socialPrevious\" min=\"1\" autofocus required> </md-input-container> <md-input-container class=\"md-display-1 md-default-theme\"> &nbsp; <md-select ng-model=\"$ctrl.startFromSocialPrevious\"> <md-option value=\"Year\">year</md-option> <md-option value=\"Month\">month</md-option> <md-option value=\"Week\">week</md-option> <md-option value=\"Day\">day</md-option> <md-option value=\"Hour\">hour</md-option> </md-select> </md-input-container> </div> <div layout-lg=\"row\" layout-gt-lg=\"row\" layout-align=\"start start\"> <div flex> <h3 class=\"md-display-1\">Amounts</h3> <div layout=\"row\" layout-margin ng-repeat-start=\"item in $ctrl.output\" ng-show=\"item.checked\"> <div flex> {{item.title}} </div> <div flex class=\"report-value\" ng-if=\"item.name == 'taxFree'\"> {{$ctrl.salary[item.name] | number:0 }}% </div> <div flex class=\"report-value\" ng-if=\"item.name != 'taxFree'\" ng-class=\"{'report-value-negative': $ctrl.salary[item.name] < 0}\"> {{($ctrl.salary[item.name] > 0 && item.sign === '+')? '+' : ''}}{{$ctrl.salary[item.name] | currency:\" € \":0}} </div> </div> <md-divider ng-if=\"!$last\" ng-show=\"item.checked\" ng-repeat-end></md-divider> </div> <div flex> <h3 class=\"md-display-1\">Options</h3> <md-content> <div layout=\"column\" layout-margin> <label>Calendar year:</label> <md-radio-group ng-model=\"$ctrl.year\"> <md-radio-button ng-repeat=\"year in $ctrl.years\" value=\"{{year}}\">{{year}}</md-radio-button> </md-radio-group> </div> </md-content> <md-content> <div layout=\"column\" layout-margin> <md-checkbox ng-model=\"$ctrl.salary.allowance\" aria-label=\"Gross salary provided includes 8% of holiday allowance\" title=\"Gross salary provided includes 8% of holiday allowance\" disabled=\"disabled\" ng-show=\"false\"> Holiday allowance included </md-checkbox> <md-checkbox ng-model=\"$ctrl.salary.socialSecurity\" aria-label=\"Social security in the Netherlands\" title=\"Social security in the Netherlands\" ng-show=\"false\"> Social security </md-checkbox> <md-checkbox ng-model=\"$ctrl.salary.older\" aria-label=\"Retirement age or older\" title=\"Retirement age or older\" ng-show=\"false\"> 65 years or older </md-checkbox> <md-checkbox ng-model=\"$ctrl.ruling.checked\" aria-label=\"Tax benefit rule for up-to 30% of gross salary\" title=\"Tax benefit rule for up-to 30% of gross salary\" ng-show=\"false\"> 30% ruling </md-checkbox>  <div class=\"collapsible-item\"> <div class=\"collapsible-heading\" ng-click=\"active = !active\" ng-class=\"{'collapsible-heading-collapsed': !active, 'collapsible-heading-expanded': active}\"> <div class=\"md-toolbar-tools\"> <button class=\"md-icon-button md-button\" type=\"button\" aria-hidden=\"false\" aria-label=\"Expand/Collapse\" title=\"Expand/Collapse\"> <md-icon md-font-library=\"material-icons\" ng-if=\"!active\">expand_more</md-icon> <md-icon md-font-library=\"material-icons\" ng-if=\"active\">expand_less</md-icon> </button> <h3 class=\"md-display-1\">Advanced Options</h3> </div> </div> <div class=\"slide-down\" ng-hide=\"!active\"> <md-content class=\"collapsible-content\"> <md-input-container> <label>Weekly working hours</label> <input type=\"number\" ng-model=\"$ctrl.salary.hours\" min=\"1\" max=\"100\"> </md-input-container> <label>Display values for:</label> <div layout-margin ng-repeat=\"item in $ctrl.output\"> <md-checkbox ng-model=\"item.checked\">{{item.title}}</md-checkbox> </div> </md-content> </div> </div> </div> </md-content> </div> </div> </md-content>";
	ngModule.run(["$templateCache",function(c){c.put("src/calc/calc.html",v1)}]);
	module.exports=v1;

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = {
		"currentYear": "2018",
		"years": [
			"2017",
			"2018",
			"2019"
		],
		"defaultWorkingHours": 40,
		"workingWeeks": 52,
		"workingDays": 260,
		"nominalExpenseRates": {
			"2016": 0.2,
			"2017": 0.2,
			"2018": 0.3,
			"2019": 0.3
		},
		"payrollTax": {
			"2017": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0.2
				}
			],
			"2018": [
				{
					"bracket": 1,
					"min": 0,
					"max": 8021.34,
					"rate": 0.16
				},
				{
					"bracket": 2,
					"min": 8021.35,
					"max": 20400,
					"rate": 0.27
				},
				{
					"bracket": 3,
					"min": 20400.01,
					"max": 48000,
					"rate": 0.34
				},
				{
					"bracket": 4,
					"min": 48000.01,
					"max": 70907.2,
					"rate": 0.39
				},
				{
					"bracket": 4,
					"min": 70907.21,
					"rate": 0.5
				}
			],
			"2019": [
				{
					"bracket": 1,
					"min": 0,
					"max": 8021.34,
					"rate": 0.16
				},
				{
					"bracket": 2,
					"min": 8021.35,
					"max": 20400,
					"rate": 0.27
				},
				{
					"bracket": 3,
					"min": 20400.01,
					"max": 48000,
					"rate": 0.34
				},
				{
					"bracket": 4,
					"min": 48000.01,
					"max": 70907.2,
					"rate": 0.39
				},
				{
					"bracket": 4,
					"min": 70907.21,
					"rate": 0.5
				}
			]
		},
		"socialPercent": {
			"2017": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0.382
				}
			],
			"2018": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0.382
				}
			],
			"2019": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0.382
				}
			]
		},
		"generalCredit": {
			"2017": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0
				}
			],
			"2018": [
				{
					"bracket": 1,
					"min": 0,
					"max": 11166.37,
					"rate": 6519.82
				},
				{
					"bracket": 2,
					"min": 11166.38,
					"max": 12570.89,
					"rate": 4418.64
				},
				{
					"bracket": 3,
					"min": 12570.9,
					"rate": 3302.7
				}
			],
			"2019": [
				{
					"bracket": 1,
					"min": 0,
					"max": 11166.37,
					"rate": 6519.82
				},
				{
					"bracket": 2,
					"min": 11166.38,
					"max": 12570.89,
					"rate": 4418.64
				},
				{
					"bracket": 3,
					"min": 12570.9,
					"rate": 3302.7
				}
			]
		},
		"labourCredit": {
			"2017": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0
				}
			],
			"2018": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0
				}
			],
			"2019": [
				{
					"bracket": 1,
					"min": 0,
					"rate": 0
				}
			]
		}
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toolbar = __webpack_require__(9);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toolbarComponent = {
	  template: _toolbar2.default
	};
	
	exports.default = toolbarComponent;

/***/ },
/* 9 */
/***/ function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<md-toolbar class=\"md-active\"> <div class=\"md-toolbar-tools\"> <h2 class=\"md-headline md-margin title\" flex=\"90\"> Normiranec Income Tax Calculator\n<span class=\"motto md-caption\">Thanks FURS :)</span> </h2> <a href=\"https://github.com/sraka1/dutch-tax-income-calculator\" flex=\"10\" layout=\"row\" layout-align=\"end center\"> <span class=\"github-alt\"> <md-tooltip md-direction=\"left\"> Fork me on GitHub </md-tooltip> </span> </a> </div> </md-toolbar>";
	ngModule.run(["$templateCache",function(c){c.put("src/toolbar/toolbar.html",v1)}]);
	module.exports=v1;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ruling = __webpack_require__(11);
	
	var _ruling2 = _interopRequireDefault(_ruling);
	
	var _data = __webpack_require__(7);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Get JSON containing calculation constants
	
	var rulingComponent = {
	  template: _ruling2.default,
	  controller: function controller($scope, $location) {
	    this.year = _data2.default.currentYear;
	    this.nominalExpenseRates = _data2.default.nominalExpenseRates;
	  }
	};
	
	exports.default = rulingComponent;

/***/ },
/* 11 */
/***/ function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<md-content layout-padding class=\"md-caption\"> <md-card> <md-card-content class=\"disclaimer\"> <b>Disclaimer</b> <p> This calculator is for illustrative purposes only. No guarantee is made for the accuracy of the data provided. Consult a qualified tax services professional before making any decision. </p> </md-card-content> </md-card> <md-card> <md-card-content> <h2 class=\"md-title\">About Social Security Tax</h2> <p> The current criteria for determining the Social Security Tax is as follows:<br> <ul> <li>Get the Tax Base for the previous year (in this case {{$ctrl.year - 1}}) - which is Previous Year Gross Income * {{$ctrl.nominalExpenseRates[$ctrl.year-1]}}</li> <li>To that, add all the Social Tax paid in the previous year. </li> <li> <b>Subtract 25% of that sum.</b> </li> <li>This is now the basis for calculating the Social Tax for year {{$ctrl.year}}. We multiply this base with 0.382 (38.2%) to get the total Yearly Social Tax to be paid this year. </li> <li><b>However, this tax has a minimum and maximum, so it cannot be lower than 4264.32€/year or higher than 25424.52€/year as of {{$ctrl.year}}.</b> </li> </ul> </p> </md-card-content> </md-card> </md-content>";
	ngModule.run(["$templateCache",function(c){c.put("src/ruling/ruling.html",v1)}]);
	module.exports=v1;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partnerSection = __webpack_require__(13);
	
	var _partnerSection2 = _interopRequireDefault(_partnerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toolbarComponent = {
	  template: _partnerSection2.default,
	  controller: function controller() {
	    this.goPartner = function () {
	      location.href = 'https://www.blueumbrella.nl/online-tax-return-netherlands/';
	    };
	  }
	};
	
	exports.default = toolbarComponent;

/***/ },
/* 13 */
/***/ function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<md-content layout-padding class=\"md-caption\"> <md-card> <md-card-content> <h2 class=\"md-title\">And more</h2> <p> Need help with your income tax filing? Check out this site about <a href=\"#\" ng-click=\"$ctrl.goPartner()\">dutch income tax return filing</a>. </p> </md-card-content> </md-card> </md-content>";
	ngModule.run(["$templateCache",function(c){c.put("src/parner-section/partner-section.html",v1)}]);
	module.exports=v1;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app.js
 **/